export const GOOGLE_SEARCH_BOX_ID = "gsc-i-id1";
export const GOOGLE_SEARCH_BUTTON_CLASS =
	"gsc-search-button gsc-search-button-v2";
